// extracted by mini-css-extract-plugin
export var banner = "HomeHero-module--banner--90e57";
export var btn = "HomeHero-module--btn--41366";
export var container = "HomeHero-module--container--72323";
export var core = "HomeHero-module--core--c405b";
export var title = "HomeHero-module--title--1a070";